import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '@aiwyn/config';
import { SharedModule } from '@aiwyn/shared';
// Imported by path, not via a services barrel: barrels here reach `common/payments`,
// which cycles back into the layout/payments modules this page participates in.
import { FirmContactService } from '../../../services/firm-contact.service';
import { ROUTE_TOKEN_QUICK_PAYMENTS } from '../../../routing-constants';

/**
 * The single dead-link page for quick payment links. Deliberately detail-free:
 * a used-up, deactivated, and never-existed link must render byte-identically,
 * so the page cannot become an oracle for probing which link ids exist.
 */
@Component({
  selector: 'app-quick-payment-link-error-page',
  templateUrl: './quick-payment-link-error-page.component.html',
  styleUrls: ['./quick-payment-link-error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class QuickPaymentLinkErrorPageComponent {
  protected readonly configService = inject(ConfigService);
  protected readonly firmContactService = inject(FirmContactService);

  private readonly router = inject(Router);
  // Same shell, two situations: a dead link (portal still works) or the whole portal switched off
  protected readonly portalOff: boolean = inject(ActivatedRoute).snapshot.data['portalOff'] === true;

  protected get firmName(): string {
    return this.configService.customerName;
  }

  protected makePaymentWithoutLink(): void {
    // Absolute navigation with empty queryParams drops the dead qpLink from the
    // URL, so the open form loads fresh instead of re-resolving the same link.
    this.router.navigate(['/', ROUTE_TOKEN_QUICK_PAYMENTS], { queryParams: {} });
  }
}
